import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Variant } from '../../product-detail.component';

@Component({
  selector: 'kion-variant-selection-item',
  templateUrl: './variant-selection-item.component.html',
  styleUrls: ['./variant-selection-item.component.scss']
})
export class VariantSelectionItemComponent {

  @Input() variant: Variant;
  // tslint:disable-next-line:no-output-native no-output-rename
  @Output('select') selectVariantEmitter: EventEmitter<{ code: string }[]> = new EventEmitter<{ code: string }[]>();

  selectVariant() {
    this.selectVariantEmitter.emit(this.variant.variantCodes);
  }
}
